import maintainRequest from "@/maintain/utils/maintainRequest";
import request from "@/utils/request";

export default function getJsSDKConfig(
  params = {
    url: window.location.href,
    agentCode: "06595eebe6c140c4b63828d7d1ab8ead",
  }
) {
  // 维修方
  if (window.location.href.indexOf("/maintain.html") != -1) {
    return maintainRequest({
      url: `/common/WeChat/getJsSDKConfig`,
      params,
    });
  } else {
    // 运营商
    return request({
      url: `/common/WeChat/getJsSDKConfig`,
      params,
    });
  }
}
